<template>
  <b-modal id="notification-preview-modal" ref="modal" title="Notification Preview" size="lg" centered hide-footer>
    <div v-if="!previewData">Loading...</div>

    <div v-else>
      <div v-if="previewType === 'email'">
        <iframe :srcdoc="previewData" style="width: 100%; height: 70vh; border: none; border-radius: 8px"></iframe>
      </div>

      <div v-else>
        <pre class="p-3 bg-light rounded" style="white-space: pre-wrap; word-break: break-word">{{ previewData }}</pre>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "NotificationTemplatePreviewModal",

  data() {
    return {
      previewType: null,
      previewData: null,
    };
  },

  methods: {
    open({ type, body }) {
      this.previewType = type;
      this.previewData = body;

      this.$refs.modal.show();
    },
  },
};
</script>
